.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-1);
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.summary strong {
  color: var(--text);
  font-weight: var(--weight-semibold);
}

.controls {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.pageSize {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.pageSizeLabel {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.select {
  padding: var(--space-1) var(--space-2);
  font-size: var(--text-sm);
  color: var(--text);
  background: var(--bg-elevated);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  cursor: pointer;
}

.buttons {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.button {
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text);
  background: var(--bg-elevated);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  min-height: 30px;
}

.button:hover:not(:disabled) {
  background: var(--bg-hover);
  border-color: var(--text-subtle);
}

.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pageIndicator {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 0 var(--space-2);
  color: var(--text);
  font-weight: var(--weight-medium);
}

.of {
  color: var(--text-subtle);
  font-weight: var(--weight-normal);
}
